module.exports = __webpack_public_path__ + "img/AP_GlidingSnow.777aa83e.svg";